import { AxiosPromise } from 'axios';

import type { Subscription } from '@/store/user/types';

import { browserApiRequest } from '../apiRequest/browserApiRequest';

/**
 * The partnership purchase endpoint, shared by both ways a campaign completes. The paid flow posts
 * here with Stripe fields; the card-less (brand) flow posts here with only the campaign id and
 * code. The backend reads the campaign's own bypass_payment flag to tell the two apart, so the
 * client never chooses between two URLs, only whether a payment screen comes first.
 *
 * The slug in the path is not read by the backend for a campaign purchase: campaign_id and code
 * fully determine the target. It is there to make the request legible in a network log.
 */
export const campaignSubscriptionsEndpoint = (campaignSlug: string): string =>
	`partnerships/${campaignSlug}/subscriptions`;

export interface CampaignRedemptionArgs {
	campaignSlug: string;
	campaignId: string;
	code: string;
}

/**
 * Redeems a code on a card-less campaign and grants the subscription in one call. Resolves with
 * the granted subscription, the same shape the paid purchase resolves with. No Stripe fields are
 * ever sent from here.
 */
export function postCampaignRedemption({
	campaignSlug,
	campaignId,
	code,
}: CampaignRedemptionArgs): AxiosPromise<Subscription> {
	return browserApiRequest({
		endpoint: campaignSubscriptionsEndpoint(campaignSlug),
		method: 'POST',
		body: {
			campaign_id: campaignId,
			code,
		},
	});
}
